/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { debounce, throttle } from 'underscore';
export const useDebouncedFunc = (func, wait = 0, deps = []) => {
  return useMemo(() => debounce(func, wait), deps);
};
export const useThrottledFunc = (func, wait = 0, deps = []) => useMemo(() => throttle(func, wait), deps);